<template>
	<v-container fluid v-if="permisoVista('mant-proveedores', 'r')">
		<v-dialog v-model="dialog" persistent max-width="500px">
			<v-card>
				<v-card-title
					>{{
						editedItem.idMantenimientoProveedor == null ? "Agregar" : "Editar"
					}}
					Proveedor</v-card-title
				>
				<v-card-text>
					<v-container fluid>
						<v-row>
							<v-col cols="12">
								<v-text-field
									v-model="editedItem.codigo"
									label="[Opcional] Código"
									:disabled="saving"
                                    clearable
								></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field
									v-model="editedItem.nombre"
									label="Nombre"
									:disabled="saving"
                                    clearable
                                    @keyup.enter="save"
									:error-messages="erroresItem.errorNombre"
									@focus="erroresItem.errorNombre = null"
								></v-text-field>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						text
						color="success"
						:disabled="saving"
						@click="closeDialog"
						>Cancelar</v-btn
					>
					<v-btn
						text
						color="error"
						:disabled="saving"
						:loading="saving"
						@click="save"
						>Guardar</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogDelete" persistent max-width="500px">
			<v-card>
				<v-card-title style="word-break: break-word"
					>¿Está seguro que desea eliminar este Proveedor?</v-card-title
				>
				<v-card-text>
					<p class="subtitle-1 text--secondary">
						Esta acción será permanente y no se puede revertir.
					</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="success"
						:disabled="deleting"
						text
						@click="closeDialog"
						>Cancelar</v-btn
					>
					<v-btn
						color="error"
						:disabled="deleting"
						:loading="deleting"
						text
						@click="deleteItem"
						>Aceptar</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-row
            :class="{
                'justify-space-between': permisoVista('mant-proveedores', 'c'),
                'justify-end': !permisoVista('mant-proveedores', 'c')
            }"
        >
			<v-col
                cols="4"
            >
				<v-btn
                    v-if="permisoVista('mant-proveedores', 'c')"
					color="primary"
					:disabled="loading"
					@click="showDialog()"
				>
					Agregar Proveedor
				</v-btn>
			</v-col>

            <v-col cols="4">
                <v-text-field
                    v-model="search"
                    label="Buscar"
                    clearable
                    prepend-inner-icon="mdi-magnify"
                    :disabled="loading"
                ></v-text-field>
            </v-col>
		</v-row>
		<v-row>
			<v-col cols="12">
				<v-data-table
					:items="proveedores"
					:headers="proveedoresHeaders"
					:loading="loading"
					:search="search"
				>
					<template v-slot:[`item.actions`]="{ item }">
						<v-tooltip bottom color="black" class="white--text">
							<template v-slot:activator="{ on }">
								<v-icon
									v-if="permisoVista('mant-proveedores', 'u')"
									v-on="on"
									small
									class="mr-2"
                                    :disabled="loading"
									@click="showDialog(item)"
								>
									edit
								</v-icon>
							</template>
							<span class="white--text">Editar</span>
						</v-tooltip>
						<v-tooltip bottom color="black" class="white--text">
							<template v-slot:activator="{ on }">
								<v-icon
									v-if="permisoVista('mant-proveedores', 'd')"
									v-on="on"
									small
                                    :disabled="loading"
									@click="showDialog(item, true)"
								>
									delete
								</v-icon>
							</template>
							<span class="white--text">Eliminar</span>
						</v-tooltip>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import axios from "axios";
export default {
	data() {
		return {
            deleting: false,
			saving: false,
			erroresItem: {
				errorNombre: null
			},
			dialogDelete: false,
			dialog: false,
			search: null,
			proveedores: [],
			proveedoresHeaders: [
				{
					text: "Nombre",
					value: "nombre",
                    align: "center",
                    width: "45%"
				},
				{
					text: "Código",
					value: "codigo",
                    align: "center",
                    width: "45%"
				},
				{
					text: "Acciones",
					value: "actions",
                    align: "center",
                    width: "10%"
				},
			],
			loading: false,
			editedItem: null,
			defaultEditedItem: {
				idMantenimientoProveedor: null,
				codigo: null,
				nombre: null,
			},
		};
	},
    beforeMount(){
        this.editedItem = structuredClone(this.defaultEditedItem);
    },
	mounted() {
		this.initialize();
	},
	methods: {
        deleteItem(){
            this.deleting = true;

            axios
                .put(`/MantenimientoProveedores/Desactivar/${this.editedItem.idMantenimientoProveedor}`)
                .then( () => {
                    this.closeDialog();
                    this.getCategoriasMantenimiento();
                    this.deleting = false;
                })
                .catch( (error) => {
                    this.deleting = false;
                    console.log(error);
                });
        },
		resetErrores(){
			for (const key in this.erroresItem) {
				this.erroresItem[key] = null;
			}
		},
		validate() {
			this.resetErrores();

			if (!this.editedItem.nombre)
				this.erroresItem.errorNombre = "Requerido";
			
			const hayErrores = Object.values(this.erroresItem).some( value => value != null);

			return !hayErrores;
		},
		save() {
			if (!this.validate()) return;

			this.saving = true;

			axios({
				url: this.editedItem.idMantenimientoProveedor == null
						? "/MantenimientoProveedores/Crear"
						: `/MantenimientoProveedores/Actualizar/${this.editedItem.idMantenimientoProveedor}`,
				method: this.editedItem.idMantenimientoProveedor == null ? "POST" : "PUT",
				data: {
					nombre: this.editedItem.nombre?.trim(),
					codigo: this.editedItem.codigo?.trim(),
				},
			})
				.then(() => {
					this.closeDialog();
                    this.getCategoriasMantenimiento();
					this.saving = false;
				})
				.catch((error) => {
					console.log(error);
					this.saving = false;
					if (error.response.status == 409)
						this.erroresItem.errorNombre = "Ya existe";
					else
						this.erroresItem.errorNombre = "Ocurrio un error. Vuelva a intentarlo";
				});
		},
		closeDialog() {
			this.dialog = false;
			this.dialogDelete = false;

			setTimeout(() => {
				this.editedItem = structuredClone(this.defaultEditedItem);
                this.resetErrores();
			}, 200);
		},
		showDialog(item = null, showDialogDelete = false) {
			this.editedItem = structuredClone(item || this.defaultEditedItem);

			if (showDialogDelete) this.dialogDelete = true;
			else this.dialog = true;
		},
		initialize() {
            this.search = null;
			this.getCategoriasMantenimiento();
		},
		getCategoriasMantenimiento() {
			this.loading = true;

			axios
				.get("/MantenimientoProveedores")
				.then((response) => {
					this.proveedores = response.data;
				})
				.catch((error) => {
					console.log(error);
					this.proveedores = [];
				})
				.finally(() => {
					this.loading = false;
				});
		},
	},
};
</script>